import { useState, useEffect, useRef } from 'react';
import { Search } from 'lucide-react';
import DynamicIcon from './dynamic-icon';


const SearchModalInput = ({
    placeholder = 'Search...',
    value = '',
    onChange = () => { },
    onSubmit = () => { },
    autoFocus = true,
    className = '',
}) => {
    const [query, setQuery] = useState(value);
    const inputRef = useRef(null);

    useEffect(() => {
        if (autoFocus && inputRef.current) {
            inputRef.current.focus();
        }
    }, [autoFocus]);

    const handleChange = (e) => {
        const newValue = e.target.value;
        setQuery(newValue);
        onChange(newValue);
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        onSubmit(query);
    };

    const handleClear = () => {
        setQuery('');
        onChange('');
        if (inputRef.current) {
            inputRef.current.focus();
        }
    };

    return (
        <form onSubmit={handleSubmit} className={`relative ${className} px-[16px] py-[12.5px]`}>
            <div className="relative flex items-center">
                <DynamicIcon name='search' color="absolute" size={20} />
                <input
                    ref={inputRef}
                    type="text"
                    value={query}
                    onChange={handleChange}
                    placeholder={placeholder}
                    className="h-[44px] w-full bg-[transparent] outline-none pl-[32px] h-[48.5px]"
                />
                {query && (
                    <DynamicIcon name='x' size={20} onClick={handleClear} />
                )}
                {!query && (
                    <div className='flex items-center gap-[4px] py-[2px] px-[4px] border-[1px] custom-border-white-200 rounded-[8px]'>
                        <div className='flex items-center gap-[4px] px-[10px] py-[11.5px] cursor-pointer poppins-medium custom-text-grey-900 custom-bg-white-200 text-[13px] rounded-[8px]'>
                            <DynamicIcon name='search' size={16} color='custom-text-grey-600' />
                            Search
                        </div>
                        <div className='flex items-center gap-[4px] px-[10px] py-[11.5px] cursor-pointer poppins-medium custom-text-grey-900 text-[13px] rounded-[8px] whitespace-nowrap'>
                            <DynamicIcon name='sparkles' size={16} color='custom-text-grey-600' />
                            Ask Ai
                        </div>
                    </div>
                )}
            </div>
        </form>
    );
};

export default SearchModalInput;